var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopoverrightarrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H20C24.4183 0 28 3.58172 28 8V18C28 22.4183 24.4183 26 20 26H2C0.895431 26 0 25.1046 0 24V2Z",
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19915_81513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7369 13.7069C14.1274 13.3164 14.1274 12.6832 13.7369 12.2927L11.4721 10.0279C11.15 9.70574 11.15 9.1834 11.4721 8.86124C11.7943 8.53907 12.3166 8.53907 12.6388 8.86124L16.0702 12.2927C16.4608 12.6832 16.4608 13.3164 16.0702 13.7069L12.6388 17.1383C12.3166 17.4605 11.7943 17.4605 11.4721 17.1383C11.15 16.8162 11.15 16.2938 11.4721 15.9717L13.7369 13.7069Z",
    fill: "#424446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19915_81513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8889,
    height: 7,
    fill: "white",
    transform: "matrix(0 -1 -1 0 17.5 18.4443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverrightarrow);
export default __webpack_public_path__ + "static/media/popoverrightarrow.447c1cbb613e54b560cf2395ede900c2.svg";
export { ForwardRef as ReactComponent };